/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminCreateWorkLogDto } from '../../models/admin-create-work-log-dto';
import { WorkLog } from '../../models/work-log';

export interface WorkLogsControllerAdminCreate$Params {
      body: AdminCreateWorkLogDto
}

export function workLogsControllerAdminCreate(http: HttpClient, rootUrl: string, params: WorkLogsControllerAdminCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkLog>> {
  const rb = new RequestBuilder(rootUrl, workLogsControllerAdminCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkLog>;
    })
  );
}

workLogsControllerAdminCreate.PATH = '/work-logs/admin-create';
